import { ENV_BRANCH, ENV_LOCAL, ENV_NEXT, ENV_PRODUCTION } from "hooks/useWhen";

export const PAYMENT_ARGS = {
  env: [],
};

export const END_OF_PILOT_ARGS = {
  env: [],
};

export const FLOODLIGHT_ARGS = {
  env: [ENV_LOCAL, ENV_NEXT, ENV_PRODUCTION],
};

//activates address autocomplete powered by Google Maps on the address input
export const ADDRESS_AUTOCOMPLETE_ARGS = {
  env: [ENV_LOCAL, ENV_NEXT, ENV_BRANCH, ENV_PRODUCTION],
};

//activates intercom and the intercom messenger launcher
export const INTERCOM_ARGS = {
  env: [ENV_LOCAL, ENV_NEXT, ENV_BRANCH, ENV_PRODUCTION],
};

//shows the end of pilot banner in the header announcing it will end on October 19th 2025
export const END_OF_PILOT_BANNER_25_ARGS = {
  env: [ENV_PRODUCTION],
};

//shows the end of pilot landing page, removes the start trade in button from the header and across the site,
//blocks creation of new trade-ins on the frontend,
//updates the end of pilot banner to say "has ended"
export const END_OF_PILOT_25_ARGS = {
  env: [ENV_PRODUCTION],
};

//removes shipping label/qr buttons, removes edit weight and appointment buttons, removes appointment times for full-x cases
export const END_OF_PILOT_EXPIRY_25_ARGS = {
  env: [ENV_PRODUCTION],
};
